module.exports = __webpack_public_path__ + "51a6130a61fe6d1a20be3b4fe76c897f.png";